export const rts = {
  handle_triggerAction: 'handle_triggerAction',
  handleSet_currentMenuType: 'handleSet_currentMenuType',
}

export const leftMenuTypes = {
  actions: 'actions',
  admins: 'admins',
  appAdmins: 'appAdmins',
  appHistory: 'appHistory',
  appInfos: 'appInfos',
  appUsers: 'appUsers',
  confirmAction: 'confirmAction',
  confirmation: 'confirmation',
  confirmInput: 'confirmInput',
  dashboards: 'dashboards',
  dataOrigins: 'dataOrigins',
  dataSources: 'dataSources',
  devices: 'devices',
  externals: 'externals',
  input: 'input',
}

export const leftMenuTriggerTypes = {
  altDatabase: 'altDatabase',
  appDataDocuments: 'appDataDocuments',
  appDataLinks: 'appDataLinks',
  appFunction: 'appFunction',
  appHistory: 'appHistory',
  appProfiles: 'appProfiles',
  appUserAccess: 'appUserAccess',
  auth: 'auth',
  confirmAction: 'confirmAction',
  dashboard: 'dashboard',
  dataOrigin: 'dataOrigin',
  dataOverride: 'dataOverride',
  dataSource: 'dataSource',
  demoApp: 'demoApp',
  demoOverride: 'demoOverride',
  device: 'device',
  frameworkLeft: 'frameworkLeft',
  gotoClient: 'gotoClient',
  gotoDemo: 'gotoDemo',
  gotoDev: 'gotoDev',
  gotoHome: 'gotoHome',
  gotoSite: 'gotoSite',
  help: 'help',
  openDb: 'openDb',
  openGs: 'openGs',
  openServiceConsole: 'openServiceConsole',
  openStorage: 'openStorage',
  prodOverride: 'prodOverride',
  search: 'search',
  settings: 'settings',
  settingsDb: 'settingsDb',
  settingsPreview: 'settingsPreview',
  staticViews: 'staticViews',
  toggle: 'toggle',
  triggerAction: 'triggerAction'
}

export const leftMenuReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleSet_currentMenuType:
      const { altOptions } = action
      const { lmt } = altOptions ?? {}
      return { ...state, currentMenuType: action.options ? action.options.lmt : null, triggerActionType: null, altTrigger: lmt }

    case rts.handle_triggerAction:
      return { ...state, triggerActionType: action.options ? action.options.lmt : null, frt: action ? action.options.frt : null }

    default:
      return { ...state }
  }
}

export const leftMenuHandlers = (dispatch) => {
  return {
    handle_triggerAction: (options) => { dispatch({ type: rts.handle_triggerAction, dispatch, options }) },
    handleSet_currentMenuType: (options, altOptions) => { dispatch({ type: rts.handleSet_currentMenuType, dispatch, options, altOptions }) },
  }
}